"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectFetchStatus = exports.selectCategoryByLocation = exports.selectPreviewOdds = exports.selectPreviewMarket = exports.selectTopMarketIdsByMatchId = exports.selectTopMarketIdsMapping = exports.selectMatchList = void 0;
var reselect_1 = require("reselect");
var core_1 = __importDefault(require("@gin-betting/core"));
var constants_1 = require("./constants");
var entities = core_1.default.entities, getRouteFromPathname = core_1.default.utils.getRouteFromPathname;
var _a = entities.selectors, selectMatch = _a.selectMatch, selectMarkets = _a.selectMarkets, selectOdds = _a.selectOdds, selectMatchIdFromProps = _a.selectMatchIdFromProps, selectLocationFromProps = _a.selectLocationFromProps;
var selectMatchList = function (state) { return state.get(constants_1.NAME); };
exports.selectMatchList = selectMatchList;
exports.selectTopMarketIdsMapping = reselect_1.createSelector(exports.selectMatchList, function (matchList) { return matchList.get('topMarketIdsMapping'); });
exports.selectTopMarketIdsByMatchId = reselect_1.createSelector(selectMatchIdFromProps, exports.selectTopMarketIdsMapping, function (matchId, topMarketIdsMapping) { return topMarketIdsMapping.get(matchId); });
exports.selectPreviewMarket = reselect_1.createSelector(selectMatch, selectMarkets, function (match, markets) {
    var marketId = match === null || match === void 0 ? void 0 : match.markets[0];
    if (!marketId)
        return undefined;
    return markets.get(marketId);
});
exports.selectPreviewOdds = reselect_1.createSelector(exports.selectPreviewMarket, selectOdds, function (market, odds) { return market === null || market === void 0 ? void 0 : market.odds.map(function (oddId) { return odds.get(oddId); }); });
exports.selectCategoryByLocation = reselect_1.createSelector(selectLocationFromProps, exports.selectMatchList, function (_a, matchList) {
    var pathname = _a.pathname;
    var categoryName = getRouteFromPathname(pathname);
    var category = matchList[categoryName];
    if (process.env.NODE_ENV === 'development' && !category)
        throw Error("Not defined match list by category: " + categoryName);
    return category;
});
exports.selectFetchStatus = reselect_1.createSelector(exports.selectCategoryByLocation, function (_a) {
    var fetchStatus = _a.fetchStatus;
    return fetchStatus;
});
//# sourceMappingURL=selectors.js.map